/**
 * Firebase Web config - **publica e versionada de proposito** (spec 0009 F2).
 *
 * Estes valores NAO sao segredo: o Firebase Web `apiKey` identifica o projeto e
 * e servido dentro do bundle do cliente para qualquer visitante. Quem autoriza
 * acesso e Security Rules + App Check + authorized domains. Mante-los como
 * GitHub secrets custava 7 entradas manuais por repo (x2 repos, x2 orgs) e
 * nenhuma rastreabilidade de qual projeto estava em producao - sem ganho algum
 * de seguranca. Versionados aqui, uma troca de projeto aparece no diff do PR.
 *
 * O que continua secret: a service account do Admin SDK, `FIREBASE_PRIVATE_KEY`,
 * tokens e `DATABASE_URL`. Nada disso entra neste arquivo.
 *
 * Precedencia: as `VITE_FIREBASE_*` do `.env` (geradas por `rt env build`)
 * vencem este mapa. Em dev nada muda; no CI o build passa a nao precisar dos
 * secrets.
 */

export type FirebaseTarget = 'dev' | 'prod'

export interface FirebaseWebConfig {
  apiKey: string
  authDomain: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  measurementId?: string
}

export const FIREBASE_WEB_CONFIG: Record<FirebaseTarget, FirebaseWebConfig> = {
  // Projeto compartilhado SysColect/VectorHub (D0001).
  dev: {
    apiKey: 'AIzaSyBEuPUkGjS5TPmCRwu3Yhn5yT-5C8gvPkM',
    authDomain: 'syscolect-ramme-2.firebaseapp.com',
    projectId: 'syscolect-ramme-2',
    storageBucket: 'syscolect-ramme-2.firebasestorage.app',
    messagingSenderId: '275980650022',
    appId: '1:275980650022:web:ee8ed6c71b3f6c9ffa48e7',
    measurementId: 'G-YXDS7NGPWW',
  },
  // Projeto de producao (spec 0009 F6). Nasce vazio: usuarios do Auth sao
  // recriados sob demanda (D1).
  prod: {
    apiKey: 'AIzaSyA5cB_pRb4RJWFF-flTH6SVeaowYEDN2fY',
    authDomain: 'ramme-tech.firebaseapp.com',
    projectId: 'ramme-tech',
    storageBucket: 'ramme-tech.firebasestorage.app',
    messagingSenderId: '423771407197',
    appId: '1:423771407197:web:001b6fddc7c9fd2c58deb4',
    measurementId: 'G-C6XD9EKSH4',
  },
}

/** Mapeia `VITE_APP_ENV` para o alvo Firebase. `staging` acompanha producao. */
export function resolveFirebaseWebConfig(appEnv: string): FirebaseWebConfig {
  return appEnv === 'production' || appEnv === 'staging'
    ? FIREBASE_WEB_CONFIG.prod
    : FIREBASE_WEB_CONFIG.dev
}
